import { render } from "./ExpensesFilters.vue?vue&type=template&id=4c495b0e"
import script from "./ExpensesFilters.vue?vue&type=script&lang=js"
export * from "./ExpensesFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__